import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

type Post = {
  title: string;
  slug: string;
};

export default function RelatedPosts({ currentSlug }: { currentSlug: string }) {
  const [posts, setPosts] = useState<Post[]>([]);

  useEffect(() => {
    const fetchPosts = async () => {
      const { data, error } = await supabase
        .from("blog_posts")
        .select("title, slug")
        .neq("slug", currentSlug); // מוודא שלא יופיע המאמר הנוכחי

      if (error) {
        console.error("Failed to load posts", error); // הדפסת שגיאות אם יש
        return;
      }

      // מערבב את הפוסטים ושולף 3 רנדומליים
      const shuffled = data?.sort(() => 0.5 - Math.random()).slice(0, 3); 
      console.log("Related Posts:", shuffled);  // בדוק אם הפוסטים נטענים כראוי
      setPosts(shuffled || []);
    };

    fetchPosts();
  }, [currentSlug]);

  if (posts.length === 0) return null;  // אם אין פוסטים להציג, מחזיר null

  return (
    <div className="mt-12 border-t pt-6 text-right">
      <h2 className="text-xl font-bold mb-4">מאמרים נוספים שאולי יעניינו אותך:</h2>
      <ul className="space-y-2">
        {posts.map((post) => (
          <li key={post.slug}>
            <a
              href={`/blog/${post.slug}`}
              className="text-orange-600 hover:underline"
            >
              {post.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}